import React from "react";

export default function InputError(props) {
  const { id, touched, errors } = props;

  if (!touched || !errors) return null;

  return (
    <p id={id} className="error" role="alert" aria-live="polite">
      {errors}
    </p>
  );
}
